import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from "@/views/LoginView.vue";
import CallCreate from "@/views/CallCreate.vue";
// import CallView from "@/views/CallView.vue";
import DashboardView from "@/views/DashboardView.vue";
import CallsGridView from "@/views/CallsGridView.vue";
import store from "@/store";
import BurnRestrictionsView from "@/views/BurnRestrictionsView.vue";
import ManualBurnRestrictionsView from "@/views/ManualBurnRestrictionsView.vue";
// import CallViewV2 from "@/views/CallViewV2.vue";
import CallView from "@/views/CallView.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/postCall',
    name: 'postCall',
    component: CallCreate,
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: '/calls/grid',
    name: 'CallsGrid',
    component: CallsGridView,
    meta: { requiresAuth: true },
  },
  {
    path:'/call/:id',
    name: 'Call',
    component: CallView,
    props: true,
    meta: {requiresAuth: true}
  },
  {
    path:'/burn',
    name: 'Burn Restrictions',
    component: BurnRestrictionsView,
  },
  {
    path:'/manualburn',
    name: 'Manual Burn Restrictions',
    component: ManualBurnRestrictionsView,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(async (to, _, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next();
      return;
    }

    await store.dispatch('viewMe');

    if (store.getters.isAuthenticated) {
      next();
      return;
    }

    next('/login');
  } else {
    next();
  }
});

export default router
